import gql from 'graphql-tag';

export const cancelCheckupReservation = gql`
  mutation cancelCheckupAppointment($input: CancelCheckupInput!) {
    cancelCheckupAppointment(input: $input) {
      empty
    }
  }
`;
